import { Upload } from 'lucide-react';
import { Button } from '@/shared/components';

interface Props {
  /** Fachlicher Name des Ordners — nicht der Speicher-Schlüssel. */
  folderName: string;
  /** Selbst angelegter Ordner (oder die Akte-Wurzel) → Ziehen ist hier erlaubt. */
  custom: boolean;
  searching: boolean;
  onUpload: () => void;
}

/**
 * Leerzustand der Content-Zone. Vorher stand hier „Noch keine Dokumente" über dem Satzfragment
 * „in dieser Kategorie." — zwei Zeilen, die zusammen keinen Satz ergeben (§11).
 */
export function AkteEmptyFolder({ folderName, custom, searching, onUpload }: Props) {
  if (searching) {
    return (
      <p className="text-ink-faint py-16 text-center text-sm">
        Keine Treffer in „{folderName}". Suchen Sie in einem anderen Ordner oder ändern Sie den
        Begriff.
      </p>
    );
  }
  return (
    <div className="border-line rounded-lg border border-dashed px-4 py-14 text-center">
      <p className="text-ink font-serif text-lg">In „{folderName}" liegt noch nichts</p>
      <p className="text-ink-soft mx-auto mb-5 mt-2 max-w-md text-sm">
        {custom
          ? 'Ziehen Sie Dateien hierher oder laden Sie das erste Dokument hoch.'
          : 'Laden Sie das erste Dokument hoch — es wird automatisch in dieser Kategorie abgelegt.'}
      </p>
      <Button variant="brand" leftIcon={<Upload size={14} />} onClick={onUpload}>
        Hochladen
      </Button>
    </div>
  );
}
